const common = {
    no_data: 'Nessun dato disponibile',
    header: {
        business_name: 'La tua attività'
    },
    download_app: {
        text: 'Per utilizzare la versione web di Simply, utilizza un laptop o un PC.',
        button: 'Scarica la versione mobile'
    },
    unknown: 'Sconosciuto',
    request_error: "Si è verificato un errore. Riprova! O contatta l'assistenza clienti per segnalare il problema.",
    home: 'Home',
    dashboard: 'Dashboard',
    product: 'Prodotto',
    add_product: 'Aggiungi Prodotto',
    edit_product: 'Modifica Prodotto',
    stock_in: 'Entrata Magazzino',
    Sales_Turnover: 'Fatturato Vendite',
    profit: 'Profitto',
    stock_out: 'Uscita Magazzino',
    staff: 'Personale',
    stock_audit: 'Verifica Magazzino',
    button: {
        save: 'Salva',
        save_and_add_more: 'Salva e Aggiungi Altro',
        submit: 'Invia',
        done: 'Completato',
        edit: 'Modifica',
        save_edit: 'Salva Modifiche',
        yes: 'Sì',
        clear: 'Cancella',
        delete: 'Elimina',
        cancel: 'Annulla',
        reset: 'Ripristina'
    },
    select_date: 'Seleziona Data',
    select_action: 'Seleziona Azione',
    mandatory: ' *(Obbligatorio)',
    not_mandatory: '(Non Obbligatorio)',
    business: 'Attività',
    account: 'Account',
    profile: 'Profilo',
    setting: 'Impostazioni',
    whichLanguage: 'Italiano',
    headerDashboard: 'Diventa VIP',
    contact_us: 'Contattaci',
    logout: 'Esci',
    category: 'Categoria',
    add_category: 'Aggiungi categoria',
    data: 'Dati',
    history: 'Cronologia',
    lowStockAlert: 'Avviso Scorta Bassa',
    Expenses: 'Spese',
    lowStockAlertButton: 'Aggiungi Quantità di Scorta di Sicurezza',
    message: {
        login_success: 'Accesso Effettuato con Successo!',
        onboard_success: 'Evviva!! Il tuo viaggio è iniziato!',
        successfully_saved: 'Dati salvati con successo',
        successfully_deleted: 'Dati eliminati con successo',
        error_required_field: 'Il campo obbligatorio non può essere vuoto',
        no_access: 'Nessun accesso',
        no_permission: "Non hai il permesso",
        error_update_history: 'Impossibile aggiornare la cronologia'
    },
    no_permission_dialog: {
        title: 'Nessun Permesso',
        description: 'Non hai il permesso di visualizzare le Spese. Contatta il tuo amministratore.'
    },
    feedback: 'Fornisci feedback',
    contact: 'Contatto',
    add: 'Aggiungi',
    supplier: 'Fornitore',
    customer: 'Cliente',
    random: 'Casuale',
    scan: 'Scansiona',
    enter: 'Accedi scansionando il codice a barre',
    terms: {
        text: 'Continuando, accetti la',
        link: 'Informativa sulla Privacy'
    },
    others: 'Altro',
    calender: {
        presets: {
            today: 'Oggi',
            yesterday: 'Ieri',
            last_7_days: 'Ultimi 7 Giorni',
            last_30_days: 'Ultimi 30 Giorni',
            this_month: 'Questo Mese',
            last_month: 'Mese Scorso',
            custom_range: 'Intervallo Personalizzato'
        }
    },
    print_large: 'Stampa Grande (A4)',
    print_letter: 'Stampa Lettera (US)',
    print_dot_matrix: 'Stampa Grande (Matrice di Punti)',
    print_medium: 'Stampa Media (75mm)',
    print_small: 'Stampa Piccola (48mm)',
    format: 'Formato carta',
    preview: 'Anteprima',
    view_invoice: 'Fattura',
    view_chalan: 'Bolla',
    price: 'Prezzo',
    stock: 'Magazzino',
    quantity: 'Quantità',
    total: 'Totale',
    print_footer_left: 'Creato da',
    print_footer_center: 'Stampato il',
    print_footer_date: 'il',
    print_to: 'A',
    language: 'Italiano',
    dateStatus: 'Ultimi 7 Giorni',
    placeholder: 'Tipo di Transazione',
    staffHistory: 'Seleziona Personale',
    languageTitle: 'Italiano',
    date: 'Data',
    download: 'Scarica',
    download_excel: 'Scarica Excel',
    download_pdf: 'Scarica Codice a Barre',
    currentTitle: 'Valuta',
    Selectperiod: 'Seleziona periodo',
    TransactionType: 'Tipo di Transazione',
    SelectCustomer: 'Seleziona Cliente',
    invoice: 'Fattura',
    login: {
        google: 'Accedi con Google',
        apple: 'Accedi con Apple'
    },
    trusted_by: {
        title: "Scelto da oltre 50.000 aziende \n in tutta l'Indonesia 🇮🇩"
    },
    privacyPolicyOne: "Effettuando l'accesso, accetti l'",
    privacyPolicyTwo: 'Informativa sulla Privacy',
    manufacture: 'Produzione',
    warehouse: 'Magazzini',
    error: {
        title: 'Ops! Qualcosa è andato storto',
        description: 'Si è verificato un errore imprevisto. Prova ad aggiornare la pagina o tornare alla home.',
        refresh: 'Aggiorna pagina',
        go_back: 'Torna alla home',
        not_found: 'Pagina non trovata'
    },
    totalPurchasePrice: 'Prezzo totale di acquisto',
    pageTotalPurchaseAmount: 'Importo totale acquisto pagina',
    approval_status: 'Stato di approvazione',
    pending: 'In attesa',
    approved: 'Approvato',
    rejected: 'Rifiutato',
    select_fields: 'Seleziona campi',
    syncWithTally: 'Sincronizza con Tally',
    importFromTally: 'Importa da Tally',
    exportToTally: 'Esporta in Tally',
    All: 'Tutti',
    Approval: 'Approvazione'
}

export default common
